import type { FC } from 'react';
import { Flex, Spinner } from '@eqi-investimentos/react';

export const Loader: FC<LoaderProps> = ({ on }) => {
  if (!on) return <></>;
  return (
    <Flex
      w="full"
      h="full"
      position="absolute"
      top="0"
      left="0"
      alignItems="center"
      justifyContent="center"
      bg="rgba(18, 19, 24, 0.8)"
      zIndex={30}
    >
      <Spinner size="xl" />
    </Flex>
  );
};

type LoaderProps = {
  on: boolean;
};
